// Где человек был в списке чатов (В4, 1.27.3): фильтр и прокрутка переживают переход
// в чат и обратно (экран списка при этом пересоздаётся). Живёт в памяти вкладки —
// новый запуск начинает со «Все» и с верха.
let view = { filter: 'all', scrollTop: 0 };

export function readChatListView() {
  return view;
}

export function saveChatListView(next = {}) {
  view = { ...view, ...next };
}
